export const getInitials = (firstName = '', lastName = '') => {
  const firstInitial = firstName.charAt(0).toUpperCase();
  const lastInitial = lastName.charAt(0).toUpperCase();
  return firstInitial + lastInitial || '?';
};

export const cleanProposalHtml = (html) => {
  if (!html || typeof html !== 'string') return html;
  return html.replace(
    /https:\/\/(pub-[a-f0-9]+\.r2\.dev\/[^\s"'>]*logo[^\s"'>]*|pub-d6f1bdf0d5ad470d9760c07d060062bf\.r2\.dev\/[^\s"'>]+)/gi,
    'https://pub-7850b80959a348cea25cdb70de6e8ddc.r2.dev/logo/Topsail-logo_RGB-03.png'
  );
};